<template>
    <div
      class="upload-box"
      :class="{'full-height' : !compose_controller.compose.attachments.count && !compose_controller.compose.attachments_upload.count}"
    >
            <div
              class="drop"
              v-window-drag-drop="{cb_drop: onAttachmentsDrop}"
            >
                <label for="editorFileUpload" class="button main-action">
                    <i class="fas fa-upload"></i>
                    <span>{{Language.say('composer.modals.choose_attachment')}}</span>
                </label>
                <span>{{Language.say('composer.modals.drag_here')}}</span>
            </div>
            <input
            @change="onAttachmentsSelect"
            id="editorFileUpload"
            type="file"
            hidden
            multiple
            >

            <ul class="drop-list" v-if="compose_controller.compose.attachments_upload.count">
                <li v-for="upload in compose_controller.compose.attachments_upload.items" :key="upload.id">
                    <div>
                        <span role="button">
                        {{ upload.file.name }}
                        </span>
                        <small>
                            {{ upload.size_text }}
                        </small>
                        <div class="progress-bar">
                            <span
                            class="fill"
                            :style="'width: ' + upload.progress_percentage + '%;'"
                            >
                        </span>
                        </div>
                    </div>
                    <ActionButton
                    @click="onUploadAbort(upload)"
                    icon='fas fa-times-circle' class='clear push-right' />
                </li>
            </ul>

            <ul class="drop-list" v-if="compose_controller.compose.attachments.count">
                <li v-for="attachment in compose_controller.compose.attachments.items" :key="attachment.id">
                    <div
                    :class="{['type-' + attachment.type] : true, 'preview-enabled': attachment.preview_url }"
                    >
                    <a
                        target="_blank"
                        :download="attachment.name"
                        :href="attachment.preview_url"
                        v-tooltip='attachment.preview_url ? "composer.modals.preview" : null'
                        >
                        <span role="button">
                        {{ attachment.name }}
                        </span>
                        <small>
                            {{ attachment.size_text }}
                        </small>
                    </a>
                    </div>
                    <ActionButton
                    @click="onAttachmentsDelete(attachment)"
                    icon='fas fa-trash-alt'
                    class='clear push-right'
                    :loading="compose_controller.state.events[`attach_id_${attachment.id}`]" />
                </li>
            </ul>
        </div>
</template>


<script setup>
  import {onBeforeMount, onUnmounted} from "vue";
  import {defineProps}                from "vue";
  import ActionButton                 from '@/vue/Elements/Buttons/ActionButton.vue';
  import Language                     from '@/js/Shared/Language/Language.js';
  import WindowDragController         from "@/js/Webmail/WindowDragController";
  import FilesEventManager            from "@/js/Shared/Events/Managers/FilesEventManager";

  const props = defineProps({
    compose_controller : {
      required: true,
    }
  })

  onBeforeMount(() => {
    WindowDragController.disable();
  });

  onUnmounted(() => {
    WindowDragController.enable();
  })

  const onAttachmentsDrop = (event) => {
    props.compose_controller.addAttachments(
      FilesEventManager.createFilesEvent(event.dataTransfer.files)
    );
  }

  const onAttachmentsSelect = (event) => {
    props.compose_controller.addAttachments(
      FilesEventManager.createFilesEvent(event.target.files)
    );
  }

  const onAttachmentsDelete = (attachment) => {
    props.compose_controller.deleteAttachmentsByTarget(attachment);
  }

  const onUploadAbort = (upload) => {
    props.compose_controller.abortUploadByTarget(upload);
  }
</script>